const getSetSessionStorage = {
  methods: {
    getSingleSessionItem(id) {
      if (!id) return
      return sessionStorage.getItem(id)
    },
    setSingleSessionItem(id, value) {
      if (!id) return
      if(value === undefined || value === null) return
      sessionStorage.setItem(id, value)
    },
    getSessionItem(id) {
      if (!id) return
      const item = sessionStorage.getItem(id)
      if (item) {
        return JSON.parse(item)
      }
      return null
    },
    setSessionItem(id, dataToStore) {
      if (!id) return
      const jsonData = JSON.stringify(dataToStore)
      if (!jsonData) return
      sessionStorage.setItem(id, jsonData)
    },
  },
}
